<template>
    <AppModal @close="onCancel" v-bind="$attrs" v-if="visible">
        <template v-slot:header>
            <slot name="header"></slot>
        </template>
        <slot default></slot>
        <template v-slot:footer>
            <button @click.prevent="onConfirm" class="btn btn-primary" type="button">Confirm
            </button>
            <button @click="onCancel" class="btn btn-danger" data-dismiss="modal" type="button">
                Cancel
            </button>
        </template>
    </AppModal>

</template>

<script>
    import AppModal from "../shared/AppModal";

    export default {
        components: {
            AppModal
        },
        props: {
            visible: {
                required: false,
                default: false
            },
            // Optional parameters to pass into the component, such as an id so that the event can be emitted
            params: {
                type: Object,
                required: false
            }
        },
        methods: {
            onClose() {
                this.$emit('close')
            },
            onConfirm() {
                this.$emit('confirm', this.params);
                this.onClose();
            },
            onCancel() {
                this.$emit('cancel', this.params);
                this.onClose();
            }
        }
    }
</script>
